// ------------------------------------
// Constants
// ------------------------------------
export const SELECT_PORTFOLIO_ITEM = 'SELECT_PORTFOLIO_ITEM'
export const DESELECT_PORTFOLIO_ITEM = 'DESELECT_PORTFOLIO_ITEM'
export const SET_PORTFOLIO_CATEGORY_FILTER = 'SET_CATEGORY_FILTER'
export const CLEAR_PORTFOLIO_ITEMS = 'CLEAR_PORTFOLIO_ITEMS'
